import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { CurrencyPipe, DatePipe, formatDate, PlatformLocation } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { AccountService } from '../_services/account.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService, PreviousRouteService } from '../_helpers/index';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { accountBankStatus, accountPSPCreation, accountPSPType } from '../_enums/account';
import { SettlementReportFilter } from '../_enums/report'
import { BatchProcessUrls } from '../_enums/urls';
import { DataService } from '../_helpers/dataservice.service'
import { AuthService } from '../_services/auth.service';
import { SettlementProcessService } from '../_services/settlementProcess.service';
import { SettlementProcess } from '../_models';
import { BackFilterService, ExcelDateConvertService, ProcessService } from '../_services';
import * as moment from 'moment';
import { QueryParamsSettlementsList } from './../_models/queryparamslist.interface';
import { Subject, Subscription, of } from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'settlementlist',
  templateUrl: './settlementlist.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class SettlementListComponent implements OnInit, OnDestroy {

  public customer_public_id: string;
  public customer_Account_public_id: string;

  excelExportData: any;
  ddlStatus: any[];

  ddlCreation: any[];
  ddlCustomerAccount: any[];
  ddlFilter: any[];

  currentDate: Date;
  startDate: Date;
  endDate: Date;

  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  isSubCustomerId: boolean;
  displayedColumns: string[] = ['select', 'created', 'reference', 'account.name', 'transfer.reference', 'gross_amount.value', 'net_amount.value', 'status'];
  dataSourceAccOperationSettlementList = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  customerPublic_key;
  isRangoVisiable = false;
  auth0Profile: any;

  isLoading = true;
  cust_account_name: any;
  pageSize: number;
  PageSizeOptions: number[];

  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  public pageStartDate: any;
  public pageEndDate: any;
  tempStatus: any;
  searchValue = '';
  excelExporSize: any;
  pageIndex: number = 0;
  pageStart: number = 0;
  filterBy: number = 1;
  configurationDetails: any;
  tempSettlementData = [];
  isExportTemplateAvailable = false;
  export_templates_list_detailed = [];
  statusDropdownValue = 0;
  creationDropdownValue = 3;
  filterDropdownValue = 1;
  statusFormControl = new FormControl(0);
  creationFormControl = new FormControl(3);
  filterFormControl = new FormControl(1);
  tempSearch: any;
  backToSearchSharedData: any;
  previousUrl: any;
  isBrowserBackButtonPressed: boolean = false;
  queryParams: QueryParamsSettlementsList = {};
  snapshotQueryParam: QueryParamsSettlementsList = {};
  startDateFromSnapshotQueryParam: boolean = false;
  endDateFromSnapshotQueryParam: boolean = false;
  timeCompleted: boolean = false;
  isExportDataAvailable: object | undefined;
  exportSubscription$ : Subscription;
  baseURL: string;
  timerId: any;
  isErrorExportAvailable: object | undefined;
  designVersion: string;

  private destroy$ = new Subject<void>();

  /** This is Constructor function which is used to initialize the class variables and objects;
   */
  constructor
    (
      private router: Router, private formBuilder: FormBuilder,
      private _fb: FormBuilder, private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private datePipe: DatePipe
      , private accountService: AccountService
      , private auth: AuthService
      , private readonly activatedRoute: ActivatedRoute
      , private _accountBankStatus: accountBankStatus
      , private _accountPSPType: accountPSPType
      , private _accountpspcreation: accountPSPCreation
      , private settlementProcessService: SettlementProcessService
      , private customerService: CustomerService
      , private spinnerService: Ng4LoadingSpinnerService
      , private _settlementReportFilter: SettlementReportFilter
      , private backFilterService: BackFilterService
      , private previousRouteService: PreviousRouteService
      , private currencyPipe: CurrencyPipe
      , private excelDateConvertService:ExcelDateConvertService
      , private processService: ProcessService
    ) {
    this.spinnerService.show();
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;

    this.isRangoVisiable = false;
    this.ddlStatus = _accountBankStatus._accountBankStatus;
    this.ddlCreation = _accountpspcreation._accountpspcreation;

    this.ddlFilter = _settlementReportFilter._settlementReportFilter

    this.isSubCustomerId = false;
    this.backFilterService.getSettlementSearchSharedData().subscribe(data => this.backToSearchSharedData = data);
    this.backFilterService.getIsBrowserBackButtonPressedSharedData().subscribe(data => this.isBrowserBackButtonPressed = data);
    
    this.designVersion = localStorage.getItem('designVersion');
    if (this.designVersion === 'V2') {
      this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V2;
    } else {
      this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V1;
    }
  }

  applyFilter() {
    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.searchValue = this.filterValue.toLowerCase().trim();
    this.getSettlementListFilterAndSearch();
  }

  /** This is ngOnInit function called after initialising the component;
 */
  ngOnInit() {
    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.isSubCustomerId = false;
        this.customer_public_id = localStorage.getItem('companyId');
      }
    }
    else {

      this.customer_public_id = localStorage.getItem('subcompanyId');

    }
    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    this.getCustomerAccountList();
    this.getConfigurationDetails();
    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";
    this.pageStartDate = this.setTodayValueFilter('00:00:00');
    this.pageEndDate = this.setTodayValueFilter('23:59:59');
    this.tempStatus = 'all';
    if (this._accountpspcreation._accountpspcreation.length > 8) {
      this._accountpspcreation._accountpspcreation.shift();
    }

    //back to search start
    this.previousUrl = this.previousRouteService.getPreviousUrl();
    if ((this.isBrowserBackButtonPressed == true) &&
      (this.previousUrl.includes("/settlements/")) &&
      (this.previousUrl.includes("/view"))
    ) {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.setBackToSearchData();
    } else {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.backFilterService.setSettlementSearchSharedData(null);
    }
    //back to search end

    this.searchFilterForm = this.formBuilder.group({
      searchText: [this.searchValue, Validators.required]
    });

    this.getSettlementList(this.customer_public_id, this.tempStatus, this.pageStartDate, this.pageEndDate, this.pageSize, this.pageStart, this.searchValue);

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setBackToSearchData() {
    if (this.backToSearchSharedData != null) {
      this.searchValue = this.backToSearchSharedData.search;
      this.tempStatus = this.backToSearchSharedData.status;
      this.statusFormControl.setValue(this.backToSearchSharedData.statusDropdownValue);
      this.creationFormControl.setValue(this.backToSearchSharedData.creationDropdownValue);
      this.filterFormControl.setValue(this.backToSearchSharedData.filterDropdownValue)
      this.statusDropdownValue = this.backToSearchSharedData.statusDropdownValue;
      this.creationDropdownValue = this.backToSearchSharedData.creationDropdownValue;
      this.filterDropdownValue = this.backToSearchSharedData.filterDropdownValue;
      this.filterBy = this.backToSearchSharedData.filterBy;
      this.pageSize = this.backToSearchSharedData.pageSize;
      this.pageIndex = this.backToSearchSharedData.pageIndex;
      this.pageStart = this.backToSearchSharedData.pageStart;
      this.paginator.pageIndex = this.pageIndex;
      if (this.filterBy == 1) {
        this.displayedColumns = ['select', 'created', 'reference', 'account.name', 'transfer.reference', 'gross_amount.value', 'net_amount.value', 'status'];
      }
      if (this.filterBy == 2) {
        this.displayedColumns = ['select', 'transfer.created', 'reference', 'account.name', 'transfer.reference', 'gross_amount.value', 'net_amount.value', 'status'];
      }
      if (this.backToSearchSharedData.creationDropdownValue == 8) {
        this.searchRangoFilterForm = this._fb.group({
          searchFromDate: [this.backToSearchSharedData.searchFromDate],
          searchToDate: [this.backToSearchSharedData.searchToDate]
        });
        this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
        this.ddlCreation.unshift({ value: 8, name: this.filterValue });
        this.isRangoVisiable = false;
        this.pageStartDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
        this.pageEndDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US')));
        this.creationFormControl.setValue(8);
        this.creationDropdownValue = 8;
      } else {
        this.pageStartDate = this.backToSearchSharedData.creationStartDate;
        this.pageEndDate = this.backToSearchSharedData.creationEndDate;
      }
      this.setBackToSearchFilter();
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceAccOperationSettlementList.data.length;
    return numSelected === numRows;
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSourceAccOperationSettlementList.data.forEach(row => this.selection.select(row));
  }

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  ngAfterViewInit() {
    this.dataSourceAccOperationSettlementList.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.dataSourceAccOperationSettlementList.sort = this.sort;
  }


  getSettlementList(customerId: string, status: string, startDate: string, endDate: string, limit: number, start: number, search: string) {

    this.snapshotQueryParam = this.activatedRoute.snapshot.queryParamMap['params'];
    if (Object.entries(this.snapshotQueryParam).length != 0) {

      let creationStateSettlementsList = JSON.parse(localStorage.getItem('creationStateSettlementsList'));
      let customCreationSettlementsRange = localStorage.getItem('customCreationSettlementsRange');

      if (this.snapshotQueryParam["pageIndex"] != undefined) {
        if(this.snapshotQueryParam["pageIndex"] != '') {
          this.queryParams.pageIndex = this.snapshotQueryParam["pageIndex"];
        } else {
          this.queryParams.pageIndex = this.pageIndex.toString();
        }
      };

      if (this.snapshotQueryParam["pageSize"] != undefined) {
        if(this.snapshotQueryParam["pageSize"] != '') {
          this.queryParams.pageSize = this.snapshotQueryParam["pageSize"];
        } else {
          this.queryParams.pageSize = this.pageSize.toString();
        }
      };

      if(this.snapshotQueryParam["startDate"] != undefined || this.snapshotQueryParam["endDate"] != undefined) {
        if(this.snapshotQueryParam["startDate"] != '') {
          this.startDateFromSnapshotQueryParam = true;
          this.queryParams.startDate = this.snapshotQueryParam["startDate"].replace(' ', '-');
        } else {
          this.queryParams.startDate = this.pageStartDate;
        }

        if(this.snapshotQueryParam["endDate"] != '') {
          this.endDateFromSnapshotQueryParam = true;
          this.queryParams.endDate = this.snapshotQueryParam["endDate"].replace(' ', '-');
        } else {
          this.queryParams.endDate = this.pageEndDate;
        }

        if (creationStateSettlementsList === 8) {
          this.creationFormControl.setValue(8);
          this.ddlCreation.unshift({ value: 8, name: customCreationSettlementsRange });
        } else {
          this.creationFormControl.setValue(creationStateSettlementsList);
        };
      };

      if (this.snapshotQueryParam["searchBy"] != undefined) {
        this.queryParams.searchBy = this.snapshotQueryParam["searchBy"];
        this.setColumnsBySnapshotQueryParam((this.queryParams.searchBy).toString());
      };

      if (this.snapshotQueryParam["status"] != undefined) {
        this.queryParams.status = this.snapshotQueryParam["status"];
        this.setStatusFormBySnapshotQueryParam(this.queryParams.status);
      };

      if (this.snapshotQueryParam["textSearch"] != undefined && this.snapshotQueryParam["textSearch"] != '') {
        this.queryParams.textSearch = this.snapshotQueryParam["textSearch"];
        this.searchFilterForm.get('searchText').setValue(this.queryParams.textSearch);
      };

      this.pageEvent(this.queryParams);
    } else {
      this.spinnerService.show();
      localStorage.setItem('creationStateSettlementsList', '3');
      this.settlementProcessService.getSettlementReportList(customerId, status, startDate, endDate, limit, start, search, this.filterBy).subscribe(data => {
        let resources = data["data"];
        this.spinnerService.hide();
        //this.paginator.firstPage();
        this.excelExporSize = data["records"];
        this.dataSourceAccOperationSettlementList.data = resources;
        this.excelExportData = resources;
        this.tempSettlementData = resources;
      },
        error => {
          this.spinnerService.hide();
          console.log('Failed! while trying to get the settlement list. ' + error.error);
        });
    }
  }

  getSettlementListFilterAndSearch() {
    this.spinnerService.show();
    this.pageStart = 0;
    this.pageIndex = 0;
    this.queryParams.pageIndex = this.pageIndex;
    this.queryParams.pageSize = this.pageSize;
    this.queryParams.startDate = this.pageStartDate;
    this.queryParams.endDate = this.pageEndDate;
    this.queryParams.searchBy = this.filterBy;
    this.queryParams.status = this.tempStatus;
    if (this.searchValue != '') {
      this.queryParams.textSearch = this.searchValue;
    } else {
      const { textSearch, ...queryParamsObject } = this.queryParams;
      this.queryParams = queryParamsObject;
    }
    this.paginator.pageIndex = 0;
    this.setBackToSearchFilter();
    this.pageEvent(this.queryParams);
  }

  pageEvent(event) {
    this.spinnerService.show();
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;

    this.queryParams.pageIndex = event["pageIndex"].toString();
    this.queryParams.pageSize = event["pageSize"].toString();

    if(event["startDate"]){
      if (this.startDateFromSnapshotQueryParam == true) {
        this.queryParams.startDate = event["startDate"];
        this.pageStartDate = this.replaceAt(10, event["startDate"], ' ');
        this.startDateFromSnapshotQueryParam = false;
      } else {
        this.pageStartDate = event["startDate"];
        this.queryParams.startDate = event["startDate"].replace(' ', '-');
      }
    } else {
      this.queryParams.startDate = this.pageStartDate.replace(' ', '-');
    };

    if(event["endDate"]){
      if (this.endDateFromSnapshotQueryParam == true) {
        this.queryParams.endDate = event["endDate"];
        this.pageEndDate = this.replaceAt(10, event["endDate"], ' ');
        this.endDateFromSnapshotQueryParam = false;
      } else {
        this.pageEndDate = event["endDate"];
        this.queryParams.endDate = event["endDate"].replace(' ', '-');
      }
    } else {
      this.queryParams.endDate = this.pageEndDate.replace(' ', '-');
    };

    if(event["searchBy"]){
      this.queryParams.searchBy = event["searchBy"];
      this.filterBy = this.queryParams.searchBy;
    } else {
      this.queryParams.searchBy = this.filterBy;
    };

    if(event["status"]){
      this.queryParams.status = event["status"];
      this.tempStatus = this.queryParams.status;
    } else {
      this.queryParams.status = this.tempStatus;
    };

    if (event["textSearch"] != undefined) {
      this.queryParams.textSearch = event["textSearch"];
      this.searchValue = this.queryParams.textSearch;
    };

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.queryParams,
      skipLocationChange: false,
      replaceUrl: true
    });

    this.settlementProcessService.getSettlementReportList(this.customer_public_id, this.tempStatus, this.pageStartDate, this.pageEndDate, this.pageSize, this.pageStart, this.searchValue, this.filterBy).subscribe(data => {
      let resources = data["data"];
      this.dataSourceAccOperationSettlementList.data = resources;
      this.excelExportData = resources;
      this.excelExporSize = data["records"];
      this.tempSettlementData = resources;
      this.spinnerService.hide();
    },
      error => {
        this.isLoading = false;
        console.log('Failed! while trying to get the settlement list. ' + error.error);
      });

    this.setBackToSearchFilter();
  }

  setColumnsBySnapshotQueryParam(status: string) {
    switch (status) {
      case '1':
        this.filterFormControl.setValue(1);
        this.displayedColumns = ['select', 'created', 'reference', 'account.name', 'transfer.reference', 'gross_amount.value', 'net_amount.value', 'status'];
        break;
      case '2':
        this.filterFormControl.setValue(2);
        this.displayedColumns = ['select', 'transfer.created', 'reference', 'account.name', 'transfer.reference', 'gross_amount.value', 'net_amount.value', 'status'];
        break;
      default:
        this.filterFormControl.setValue(1);
    }
  }

  setStatusFormBySnapshotQueryParam(status: string) {
    switch (status) {
      case 'all':
        this.statusFormControl.setValue(0);
        break;
      case '(1)':
        this.statusFormControl.setValue(1);
        break;
      case '(2)':
        this.statusFormControl.setValue(2);
        break;
      case '(3)':
        this.statusFormControl.setValue(3);
        break;
      case '(4)':
        this.statusFormControl.setValue(4);
        break;
      default:
        this.statusFormControl.setValue(0);
    }
  }

  replaceAt(index, textToReplace, character) {
    let chars = textToReplace.split('');
    chars[index] = character;
    return chars.join('');
  }

  /** This function is used to get the invoices list from the service;
 * it accepts the param customerId
 */
  /*
           * This function is used to get the customer account list from the service; *
      */
  getCustomerAccountList() {
    this.customerService.getCustomerAccountList(this.customer_public_id).subscribe(data => {
      let resourcesReturn = data;
      this.ddlCustomerAccount = resourcesReturn;
      this.ddlCustomerAccount = this.ddlCustomerAccount.filter(t => t.type === 'COLLECT');
    },
      error => {
        console.log('Failed while trying to the Search All Result. ' + error.error);
      });
  }//end

  GetAccountsDetails() {
    this.accountService.getAccount(this.customer_Account_public_id).subscribe(data => {
      this.cust_account_name = data.name;
    },
      error => {
        console.log('Failed! while trying to get the invoices list. ' + error.error);
      });
  }//end

  filterSettlementDetails(filter) {
    this.filterDropdownValue = filter;
    if (filter == 1) {
      this.filterBy = 1;
      this.displayedColumns = ['select', 'created', 'reference', 'account.name', 'transfer.reference', 'gross_amount.value', 'net_amount.value', 'status'];
    }
    if (filter == 2) {
      this.filterBy = 2;
      this.displayedColumns = ['select', 'transfer.created', 'reference', 'account.name', 'transfer.reference', 'gross_amount.value', 'net_amount.value', 'status'];
    }
    this.dataSourceAccOperationSettlementList.data = [];
    this.excelExporSize = 0;
    this.getSettlementListFilterAndSearch();
  }

  filterAccountCreationDetails(creation) {
    this.creationDropdownValue = creation;
    if(creation != 7) {
      localStorage.setItem('creationStateSettlementsList', creation);
    };
    var currentDate = new Date();
    var currentDate1 = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(currentweekFirstDate.getDate() - 7);
    currentweekLastDate.setDate(currentweekLastDate.getDate() - (currentweekLastDate.getDay() - 1) + 6);


    // All Datas Condition
    if (creation == 0) {
      this.pageStartDate = "2017-01-01";
      this.pageEndDate = "2030-01-01";
      this.getSettlementListFilterAndSearch();
    }

    // Current Month Filter Condition
    if (creation == 1) {
      let CurrentmonthFirstDate = new Date(formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let CurrentmonthEndDate = new Date(formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      this.pageStartDate = this.convertGMTTime(CurrentmonthFirstDate);
      this.pageEndDate = this.convertGMTTime(CurrentmonthEndDate);
      this.getSettlementListFilterAndSearch();
    }

    // Current Week Filter Condition
    if (creation == 2) {
      var WeekstartDate1 = new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      var WeekendDate1 = new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));

      let WeekstartDate = this.convertGMTTime(WeekstartDate1);
      let WeekendDate = this.convertGMTTime(WeekendDate1);

      this.pageStartDate = WeekstartDate;
      this.pageEndDate = WeekendDate;
      this.getSettlementListFilterAndSearch();
    }

    // Today Filter Condition
    if (creation == 3) {
      currentDate.setDate(currentDate.getDate());
      currentDate1.setDate(currentDate1.getDate());

      var todayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let startDate = this.convertGMTTime(todayStartDate);

      var todayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let endDate = this.convertGMTTime(todayEndDate);
      this.pageStartDate = startDate;
      this.pageEndDate = endDate;
      this.getSettlementListFilterAndSearch();
    }

    // Yesterday Filter Condition
    if (creation == 4) {
      currentDate.setDate(currentDate.getDate() - 1);
      currentDate1.setDate(currentDate1.getDate() - 1);

      var yeaterdayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let startDate = this.convertGMTTime(yeaterdayStartDate);

      var yesterdayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let endDate = this.convertGMTTime(yesterdayEndDate);

      this.pageStartDate = startDate;
      this.pageEndDate = endDate;
      this.getSettlementListFilterAndSearch();
    }


    // Last Week Filter Condition
    if (creation == 5) {
      let lastWeekstartDate = new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let lastWeekendDate = new Date(formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));

      this.pageStartDate = this.convertGMTTime(lastWeekstartDate);
      this.pageEndDate = this.convertGMTTime(lastWeekendDate);
      this.getSettlementListFilterAndSearch();
    }

    // Last Month Filter Condition
    if (creation == 6) {
      let LastmonthFirstDate = new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let LastmonthEndDate = new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      this.pageStartDate = this.convertGMTTime(LastmonthFirstDate);
      this.pageEndDate = this.convertGMTTime(LastmonthEndDate);
      this.getSettlementListFilterAndSearch();
    }
    if (creation == 7) {

      this.isRangoVisiable = true;
    }
    else {
      this.isRangoVisiable = false;
    }
    if (creation == 8) {
      this.filterRangoExpDetails()
    }
    this.setBackToSearchFilter();
  }

  filterStatusDetails(status) {
    this.statusDropdownValue = status;
    if (status == this.ddlStatus[0].value) {
      this.tempStatus = 'all';
    }
    else if (status == this.ddlStatus[1].value) {
      this.tempStatus = '(1)';
    }
    else if (status == this.ddlStatus[2].value) {
      this.tempStatus = '(2)';
    }
    else if (status == this.ddlStatus[3].value) {
      this.tempStatus = '(3)';
    }
    else if (status == this.ddlStatus[4].value) {
      this.tempStatus = '(4)';
    }
    else {
      this.tempStatus = status;
    }
    this.getSettlementListFilterAndSearch();
  }


  /** This function is used to filter the Account list based on Status wise;
  * it accepts the param select status value
  */
  filterAccountNameDetails(status) {

    if (status == this.ddlStatus[0].value) {
      this.dataSourceAccOperationSettlementList.filter = '';
    }
    else {
      this.dataSourceAccOperationSettlementList.filter = '';
      this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
        data.status == 'NEW';
      this.dataSourceAccOperationSettlementList.filter = 'NEW';
    }




  }//end


  /** This function is used to filter the invoices list based on Experience Rango From and To Date wise;
     * it accepts the param select status value
     */
  filterRangoExpDetails() {

    if (this._accountpspcreation._accountpspcreation.length > 8) {
      this._accountpspcreation._accountpspcreation.shift();
    }
    if (this.searchRangoFilterForm.controls.searchFromDate.value != '' && this.searchRangoFilterForm.controls.searchToDate.value != '') {
      localStorage.setItem('creationStateSettlementsList', '8');
      this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
      localStorage.setItem('customCreationSettlementsRange', this.filterValue);
      this.ddlCreation.unshift({ value: 8, name: this.filterValue });


      this.isRangoVisiable = false;


      //this.dataSourceAccOperationSettlementList.filter = '';
      let CurrentmonthFirstDate = new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let CurrentmonthEndDate = new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US'));

      this.pageStartDate = this.convertGMTTime(CurrentmonthFirstDate);
      this.pageEndDate = this.convertGMTTime(CurrentmonthEndDate);
      this.creationFormControl.setValue(8);
      this.creationDropdownValue = 8;
    } else {
      localStorage.setItem('creationStateSettlementsList', '3');
      this.isRangoVisiable = false;
      this.creationFormControl.setValue(3);
      this.creationDropdownValue = 3;
      this.pageStartDate = this.setTodayValueFilter('00:00:00');
      this.pageEndDate = this.setTodayValueFilter('23:59:59');
    }
    this.getSettlementListFilterAndSearch();
  }


  exportAsXLSX() {
    this.spinnerService.show();
    if (this.selection.selected.length == 0) {
      this.settlementProcessService.multipleExportAsXLSX(this.customer_public_id, this.tempStatus, this.pageStartDate, this.pageEndDate, 500000, 0, this.searchValue, this.filterBy)
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {
          try {
            const url = data.storage_url;
            location.href = url;
          } catch (error) {
            console.error('Failed! while trying to export settlement list. ' + error.error);
          }
          this.spinnerService.hide();
        }),
        catchError(error => {
          this.spinnerService.hide();
          console.error('Failed! while trying to export settlement list. ' + error.error);
          return of(null);
        }),
        finalize(() => this.spinnerService.hide())
      )
      .subscribe();
    } else {
      this.setExportExcelFileData(this.selection.selected);
      this.spinnerService.hide();
    }
  }


  setExportExcelFileData(excelExportData) {
    var excelHeader = ["FECHA DE LIQUIDACIÓN", "FECHA DE TRANSFERENCIA", "REFERENCIA", "CUENTA", "OPERACION", "TOTAL", "TOTAL NETO", "ESTADO"]
    var arrFinalData = [];
    var object_temp = {};
    var k = 0;
    var columnsKeyNames = [];

    for (k = 0; k < excelExportData.length; k++) {
      var singleRec_temp = excelExportData[k];
      delete singleRec_temp['fees_amount'];
      delete singleRec_temp['id'];
      delete singleRec_temp['livemode'];
      delete singleRec_temp['object'];
      delete singleRec_temp['tax_amount'];

      columnsKeyNames = Object.keys(singleRec_temp);
      var created_temp;
      var reference_temp;
      var account_temp;
      var operation_temp;
      var total_temp;
      var net_amount_temp;
      var status_temp;
      var transferDate_temp;
      object_temp = {};

      for (var i = 0; i < columnsKeyNames.length; i++) {
        if (columnsKeyNames[i] == "created") {
         // var startDate1 = new Date(formatDate(singleRec_temp[columnsKeyNames[i]], 'yyyy-MM-dd hh:mm:ss', 'en-US'));
          let createdate = this.excelDateConvertService.convertExcelDateTime(singleRec_temp[columnsKeyNames[i]]);
          created_temp = createdate;
        }

        if (columnsKeyNames[i] == "reference") {
          reference_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "account") {
          account_temp = singleRec_temp[columnsKeyNames[i]].name;

        }

        if (columnsKeyNames[i] == "transfer") {
          operation_temp = singleRec_temp[columnsKeyNames[i]].reference;
          if (singleRec_temp[columnsKeyNames[i]].created !== undefined) {
           // var tempDate = new Date(formatDate(singleRec_temp[columnsKeyNames[i]].created, 'yyyy-MM-dd hh:mm:ss', 'en-US'));
            let transferDate = this.excelDateConvertService.convertExcelDateTime(singleRec_temp[columnsKeyNames[i]].created);
            transferDate_temp = transferDate;
          }
        }

        if (columnsKeyNames[i] == "gross_amount") {
          total_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[i]].value, "", "");
        }

        if (columnsKeyNames[i] == "net_amount") {
          net_amount_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[i]].value, "", "");
        }

        var statusEnglish;
        if (columnsKeyNames[i] == "status") {
          statusEnglish = singleRec_temp[columnsKeyNames[i]];

          switch (statusEnglish) {
            case 'NEW':
              status_temp = 'Pendiente'
              break;
            case 'PENDING':
              status_temp = 'Pendiente'
              break;
            case 'PROCESSING':
              status_temp = 'Pendiente'
              break;
            case 'CONFIRMED':
              status_temp = 'Confirmado'
              break;
            case 'CANCELLED':
              status_temp = 'Cancelado'
              break;
            case 'PAID':
              status_temp = 'Pagado'
              break;
            case 'VOIDED':
              status_temp = 'Anulado'
              break;
            case 'EXPIRED':
              status_temp = 'Expirado'
              break;
            case 'VOIDED_CUSTOMER':
              status_temp = 'Anulado'
              break;
            case 'OVERDUE':
              status_temp = 'Vencido'
              break;
            case 'PAYMENT_ON_HOLD':
              status_temp = 'Pendiente'
              break;
            default:
              status_temp = statusEnglish;

          }//end switch
        }
      }

      arrFinalData.push([created_temp, transferDate_temp, reference_temp, account_temp, operation_temp, total_temp, net_amount_temp, status_temp])
      // for (var j = 0; j < excelHeader.length; j++) {
      //   if (excelHeader[j] == "Fecha de Liquidación") {
      //     object_temp[excelHeader[j]] = created_temp;
      //   }
      //   if (excelHeader[j] == "Fecha de Transferencia") {
      //     object_temp[excelHeader[j]] = transferDate_temp;
      //   }

      //   if (excelHeader[j] == "Referencia") {
      //     object_temp[excelHeader[j]] = reference_temp;
      //   }
      //   if (excelHeader[j] == "Cuenta") {
      //     object_temp[excelHeader[j]] = account_temp;
      //   }
      //   if (excelHeader[j] == "Operacion") {
      //     object_temp[excelHeader[j]] = operation_temp;
      //   }
      //   if (excelHeader[j] == "Total") {
      //     object_temp[excelHeader[j]] = total_temp;
      //   }
      //   if (excelHeader[j] == "Total Neto") {
      //     object_temp[excelHeader[j]] = net_amount_temp;
      //   }
      //   if (excelHeader[j] == "Estado") {
      //     object_temp[excelHeader[j]] = status_temp;
      //   }
      // }//end for excel header j


      // arrFinalData.push(object_temp);

    }
    this.excelService.generateSettlementExcelFile(excelHeader, arrFinalData, 'SettlementList');
    this.spinnerService.hide();

  }//end function

  convertGMTTime(startDate1) {
    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
    else {
      var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }



  }

  //Convert GMT Excel Export

  // convertExcelGMTTime(startDate1) {
  //   let date: any = new Date(startDate1);
  //   var dateTimeZoneDiff = new Date(date);
  //   dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
  //   let startDate = formatDate(dateTimeZoneDiff, 'DD/MM/YYYY hh:mm:ss a', 'en-US');
  //   return startDate;

  // }

  // convertExcelGMTTime(value) {
  //   var dateTimeZoneDiff = value.split(/[- :]/),
  //     dateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
  //   dateFinal.setMilliseconds(Number(this.offsetTimeVal));
  //   var dateString = moment(dateFinal).format('MM/DD/YYYY HH:mm:ss');
  //   var dateObj = new Date(dateString);
  //   var momentObj = moment(dateObj);
  //   var momentString = momentObj.format('DD/MM/YYYY HH:mm:ss'); // 2016-07
  //   return momentString;
  // }


  viewSettlementURL(element) {
    if (this.isSubCustomerId == true) {
      this.router.navigate([`/dashboard/${this.customer_public_id}`]);
    }
    else {
      this.router.navigate([`/settlements/${element.public_id}/view`]);
    }
  }


  getConfigurationDetails() {
    this.settlementProcessService.getConfigurationDetails(this.customer_public_id).subscribe(data => {
      this.configurationDetails = data;
      if (this.configurationDetails != null && this.configurationDetails != undefined) {
        if (this.configurationDetails.values.export_templates_list_detailed != null && this.configurationDetails.values.export_templates_list_detailed != undefined) {
          if (Array.isArray(this.configurationDetails.values.export_templates_list_detailed)) {
            this.isExportTemplateAvailable = true;
            this.export_templates_list_detailed = this.configurationDetails.values.export_templates_list_detailed;
          }

        }
      }
    },
      err => {
        console.log('Failed while trying to get configuration details.' + err.error);
      })
  }

  checkResponseExportTime() {
    this.timerId = setTimeout(() => {
      if (this.isExportDataAvailable == undefined && this.isErrorExportAvailable == undefined) {
        this.spinnerService.hide();
        this.timeCompleted = true;
        this.exportSubscription$.unsubscribe();
      }
    }, 11000);
  }

  exportTemplate(template) {
    this.spinnerService.show();
    clearTimeout(this.timerId);
    this.isExportDataAvailable = undefined;
    this.isErrorExportAvailable = undefined;

    let body = {
      "customer": { "public_id": this.customer_public_id },
      "settlement_process_list": [],
      "template": template
    }

    if (this.selection.selected.length == 0) {
      this.tempSettlementData.forEach(data => {
        let tempValue = { "public_id": data.public_id };
        body.settlement_process_list.push(tempValue);
      })
    } else {
      this.selection.selected.forEach(data => {
        let tempValue = { "public_id": data.public_id };
        body.settlement_process_list.push(tempValue);
      })
    }

    this.checkResponseExportTime();
    this.exportSubscription$ = this.settlementProcessService.multipleExportAsTXT(body).subscribe(result => {
      this.isExportDataAvailable = result;
      if (result.body.storage_url != undefined) {
        location.href = result.body.storage_url;
      } else {
        console.log(result.body);
      }
      this.spinnerService.hide();
    }, err => {
      this.isErrorExportAvailable = err;
      console.log('Failed while trying to get the export.' + err.error);
      this.spinnerService.hide();
    })
  }

  exportAsTXT() {
    this.spinnerService.show();
    let body = {
      "customer": { "public_id": this.customer_public_id },
      "settlement_process_list": [],
      "template": this.configurationDetails.values.export_template
    }
    if (this.selection.selected.length == 0) {
      this.tempSettlementData.forEach(data => {
        let tempValue = { "public_id": data.public_id };
        body.settlement_process_list.push(tempValue);
      })
    } else {
      this.selection.selected.forEach(data => {
        let tempValue = { "public_id": data.public_id };
        body.settlement_process_list.push(tempValue);
      })
    }

    this.settlementProcessService.multipleExportAsTXT(body).subscribe(result => {
      if (result.body.storage_url != undefined) {
        location.href = result.body.storage_url;
      } else {
        console.log(result.body);
      }
      this.spinnerService.hide();
    },
      err => {
        this.spinnerService.hide();
        console.log('Failed while trying to get the multiple export.' + err.error);
      })
  }

  closeModal() {
    this.timeCompleted = false;
  };

  setBackToSearchFilter() {
    this.tempSearch = {
      search: this.searchValue,
      creationStartDate: this.pageStartDate,
      creationEndDate: this.pageEndDate,
      status: this.tempStatus,
      statusDropdownValue: this.statusDropdownValue,
      creationDropdownValue: this.creationDropdownValue,
      filterDropdownValue: this.filterDropdownValue,
      searchFromDate: this.searchRangoFilterForm.controls.searchFromDate.value,
      searchToDate: this.searchRangoFilterForm.controls.searchToDate.value,
      filterBy: this.filterBy,
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      pageStart: this.pageStart
    }
    this.backFilterService.setSettlementSearchSharedData(this.tempSearch);
  }

  setTodayValueFilter(hour: string) {
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    var todaySelectedHour = new Date(formatDate(currentDate, `yyyy-MM-dd ${hour}`, 'en-US'));
    let todayDate = this.convertGMTTime(todaySelectedHour);
    return todayDate;
  }
}//end class


